<template>
  <div>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">利用者(ケアマネっ子)</li>
          </ol>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <!-- Column -->
          <div class="card">
            <div class="card-body">
              <div class="">
                <div class="row">
                  <div class="col-4">
                    <div class="form-group" :class="{'has-danger': validationErrors.office_id }">
                      <label class="control-label">事業所</label>
                      <select-office v-model="officeId" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">
                    <div class="form-group" :class="{'has-danger': validationErrors.file }">
                      <label class="control-label">ファイル</label>
                      <input type="file" class="form-control"
                             accept=".csv"
                             @change="handleFileChange" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-actions">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <button type="submit" class="action-button btn btn-success btn-rounded" @click.prevent="handleSave">
                      インポート
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
      </div>
      <div class="row" v-show="hasErrors">
        <div class="col-md-12">
          <div class="alert alert-warning">
            <button type="button" class="close" @click="clearErrors" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <ul>
              <li v-for="(error, index) in errorsList" :key="index">
                {{ error }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useToast } from 'vue-toastification'
import api from '../../libs/Api'
import SelectOffice from '../../components/SelectOffice'

const toast = useToast()

// Form inputs
const officeId = ref(null)
const file = ref(null)
const isProcessing = ref(false)
const validationErrors = ref({})
const messages = ref([])

const hasErrors = computed(() => {
  return Object.keys(validationErrors.value).length > 0 || messages.value.length > 0
})

const errorsList = computed(() => {
  const list = [...messages.value]
  Object.values(validationErrors.value).forEach(error => {
    if (error) list.push(error)
  })
  return list
})

const validateField = (field) => {
  validationErrors.value[field] = null

  if (field === 'office_id' && !officeId.value) {
    validationErrors.value.office_id = '事業所は必須項目です'
    return false
  }

  if (field === 'file' && !file.value) {
    validationErrors.value.file = 'ファイルは必須項目です'
    return false
  }

  return true
}

const validateForm = () => {
  const isOfficeValid = validateField('office_id')
  const isFileValid = validateField('file')
  return isOfficeValid && isFileValid
}

const clearErrors = () => {
  validationErrors.value = {}
  messages.value = []
}

const handleFileChange = (e) => {
  const files = e.target.files || e.dataTransfer.files
  file.value = files[0]
}

const handleSave = async () => {
  try {
    clearErrors()

    if (!validateForm()) {
      return
    }

    isProcessing.value = true

    const result = await api.importF1User({
      office_id: officeId.value,
      file: file.value
    })

    toast.success('インポートに成功しました。', {
      position: 'top-center',
      timeout: 2000
    })

    if (result && result.length !== 0) {
      validationErrors.value.file = '上記の行数が取り込めませんでした。'
      result.forEach(e => {
        messages.value.push(e)
      })
    }
  } catch (error) {
    console.error(error)
    toast.error('処理中にエラーが発生しました')
  } finally {
    isProcessing.value = false
  }
}
</script>

<style lang="scss" scoped>
.data-actions {
  text-align: right;
}

.table th {
  background-color: #99abb4 !important;
}
</style>
